import { SetupProgressResponse } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchSetupProgress = async (signal) => SetupProgressResponse.parse(await request('/api/v1/communication/setup-progress', { signal })).steps;
//# sourceMappingURL=communication-setup.js.map